import React from 'react'

function AboutContent() {
  return (
    <div className="about-content">
          <div className="about-container">
     <div className="about-item">
     <div><h2 className="about-title">About </h2></div>
      <p> Lorem ipsum dolor sit amet consectetur adipisicing elit.<br></br>
         Maxime incidunt perferendis animi quasi,<br></br> non accusamus fugit sit sint nesciunt<br></br> 
        corrupti placeat eligendi consequuntur pariatur!<br></br> Commodi sequi nihil esse ipsa deserunt. </p>
     </div>
     <div className="about-item">
      <p><video className="video-container" src="./imges/testingnail.mp4" muted autoPlay loop ></video></p>

     </div>

     </div>

    </div>
  )
}

export default AboutContent;